import React from "react";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";

import Button from "react-bootstrap/Button";
import { LinkContainer } from "react-router-bootstrap";

import RPaketTable from "./RPaketTable";
import BankStatements from "./BankStatements";
import YearlyReportSummaryDisabled from "./YearlyReportSummaryDisabled";
// TODO: Reenable when ready
// import YearlyReportSummaryDisabled from "./YearlyReportSummaryDisabled";

export default class SummaryTable extends React.Component {
  render() {
    return (
      <>
        <div className="sitecontent">
          <Container fluid>
            <Row>
              <Col xs={12}>
                <Tabs defaultActiveKey="rpaket" id="summary-table">
                  <Tab eventKey="rpaket" title="Abrechnungsbelege">
                    <RPaketTable>
                      <LinkContainer
                        to="/vorgaenge"
                        style={{
                          marginLeft: "30%",
                          marginRight: "30%",
                          width: "40%",
                        }}
                      >
                        <Button href="/vorgaenge" variant="light">
                          Alle Vorgänge anzeigen
                        </Button>
                      </LinkContainer>
                    </RPaketTable>
                  </Tab>
                  <Tab eventKey="bs" title="Kontoauszüge">
                    <BankStatements />
                  </Tab>
                  <Tab eventKey="jb" title={<span>Jahreszusammenfassung<span className="icon-lock ml-2" /></span>}>
                    <YearlyReportSummaryDisabled />
                  </Tab>
                </Tabs>
              </Col>
            </Row>
          </Container>
        </div>
      </>
    );
  }
}
